import joi from 'joi';
import z from 'zod';
import { $bool } from '../../zod/utils/boolean';
import { ProfileUpsert, ProfileUpsertMembership } from '../types/profile';
import {
  profileAddressSchema,
  profileBirthdaySchema,
  profileIdentitiesSchema,
  profileLanguageSchema,
  profilePictureUrlSchema,
} from './profile-schema';

export const profileUpsertMembershipSchema = joi.object<ProfileUpsertMembership>({
  programId: joi.string().uuid().required(),
  accessDenied: joi.boolean().optional(),
});

export const profileUpsertMembershipsSchema = joi.array().items(profileUpsertMembershipSchema);
export const $UpsertProfileTokenExtraInfo = z.object({
  programId: z.string().uuid().optional(),
});

export const $UpsertProfileQuery = z.object({
  lookupByIdentity: z.string().optional(),
  impersonate: $bool.default(false).optional(),
  cookieDuration: z.coerce.number().optional(),
  internalUser: $bool.default(false).optional(),
  tokenExtraInfo: $UpsertProfileTokenExtraInfo.optional(),
});

export type UpsertProfileQuery = z.infer<typeof $UpsertProfileQuery>;
export type UpsertProfileTokenExtraInfo = z.infer<typeof $UpsertProfileTokenExtraInfo>;

export const profileUpsertSchema = joi.object<ProfileUpsert>({
  id: joi.string().empty('').optional(),
  isTestUser: joi.boolean().optional(),
  email: joi.when('$emailOptional', {
    is: true,
    then: joi.string().email({ tlds: false }).optional(),
    otherwise: joi.string().email({ tlds: false }).required(),
  }),
  firstName: joi.string().optional().empty('').allow(null),
  lastName: joi.string().optional().empty('').allow(null),
  birthday: profileBirthdaySchema.optional().allow(null),
  picture: profilePictureUrlSchema.optional().allow(null),
  address: profileAddressSchema.optional().allow(null),
  phone: joi.string().optional().allow(null),
  gender: joi.string().optional().allow(null),
  // TODO validate with npm package iso-66 code list
  language: profileLanguageSchema.optional().allow(null),
  identities: profileIdentitiesSchema.min(1).optional().default([]),
  memberships: profileUpsertMembershipsSchema.optional(),
  customKeys: joi.object().optional().default({}),
  referralCode: joi.string().empty('').optional(),
});

export const profilesUpsertSchema = joi.array().items(profileUpsertSchema).min(1);
